import React from 'react';
import { Container } from 'react-bootstrap';
import DevelopmentBanner from './DevelopmentBanner';
import './HomeHero.css';

/**
 * Home branding band: SDG horizontal logo (no UN emblem) + title/description.
 * Optional development notice sits bottom-right (CMS toggle).
 */
const HomeHero = ({
  title,
  subtitle,
  logoSrc = '/sdg-logo/logo-horizontal.png',
}) => {
  return (
    <section className="home-hero" aria-labelledby="home-hero-heading">
      <Container className="home-hero__inner">
        <div className="home-hero__row">
          <div className="home-hero__copy">
            <img
              src={logoSrc}
              alt="Sustainable Development Goals"
              className="home-hero__logo"
              id="home-hero-heading"
            />
            <h1 className="home-hero__title">{title}</h1>
            {subtitle ? <p className="home-hero__subtitle">{subtitle}</p> : null}
          </div>
          <DevelopmentBanner />
        </div>
      </Container>
    </section>
  );
};

export default HomeHero;
